<div
  class="wuc-skeleton"
  [class.wuc-skeleton--circle]="shape === 'circle'"
  [class.wuc-skeleton--square]="shape === 'square'"
>
  <ng-content></ng-content>
</div>
